package dev.lingvo.site.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import dev.lingvo.site.ds.Space
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import dev.lingvo.site.components.marketing.CloseBand
import dev.lingvo.site.components.marketing.AgentValueBand
import dev.lingvo.site.components.marketing.FormatsBand
import dev.lingvo.site.components.marketing.HeroPitch
import dev.lingvo.site.components.marketing.INSTRUMENT_INITIAL_COUNT
import dev.lingvo.site.components.marketing.LoopBand
import dev.lingvo.site.components.marketing.PluralsBand
import dev.lingvo.site.components.marketing.PublicFooter
import dev.lingvo.site.components.marketing.PublicHeader
import dev.lingvo.site.ds.toSitePalette
import kotlinx.browser.document
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Main
import dev.lingvo.site.i18n.tr

val LandingContentStyle = CssStyle.base {
    Modifier.position(Position.Relative).zIndex(1)
}

/**
 * The hero is the one band that sets its own edges.
 *
 * Every other band goes through `Band`, which owns the gutter. The hero sets its own vertical
 * rhythm for the product introduction while sharing the page's content width.
 */
val HeroStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .maxWidth(Space.PageMax)
            .padding(top = Space.Hero, bottom = Space.Gutter, leftRight = Space.Gutter)
            .styleModifier {
                property("display", "flex")
                property("flex-direction", "column")
                property("gap", Space.Section.toString())
                // Keep the introduction aligned with each band's interior on wide screens.
                property("margin-inline", "auto")
            }
    }
    Breakpoint.ZERO { Modifier.padding(top = Space.XXXL, bottom = Space.Section, leftRight = Space.XL) }
    Breakpoint.MD { Modifier.padding(top = Space.Section, bottom = Space.Hero, leftRight = Space.Hero) }
    Breakpoint.LG { Modifier.padding(top = Space.Hero, bottom = Space.Gutter, leftRight = Space.Gutter) }
}

val LandingPageStyle = CssStyle.base {
    Modifier
        .position(Position.Relative)
        .minHeight(100.vh)
        .backgroundColor(colorMode.toSitePalette().surfaceBase)
        .color(colorMode.toSitePalette().textPrimary)
}

@Page
@Composable
fun HomePage() {
    var count by remember { mutableStateOf(INSTRUMENT_INITIAL_COUNT) }
    LaunchedEffect(Unit) {
        document.title = tr("index.lingvo_app_localization_review", "Lingvo — app localization and review")
    }
    Div(LandingPageStyle.toModifier().toAttrs()) {
        Div(LandingContentStyle.toModifier().toAttrs()) {
            PublicHeader()
            Main {
                Div(HeroStyle.toModifier().toAttrs()) {
                    HeroPitch()
                }
                Div(Modifier.styleModifier { property("scroll-margin-top", "96px") }.toAttrs { attr("id", "workflow") }) {
                    LoopBand()
                }
                AgentValueBand()
                PluralsBand(count = count, onCount = { count = it })
                FormatsBand()
                CloseBand()
            }
            PublicFooter()
        }
    }
}
